import { DesignManifoldDetailsFormModel } from '../shared/quote-or-design-form/manifolds/designManifoldDetailsFormModel';

export type DesignManifoldDetailsResponse = {
  flowTemperatureInDegreesCelsius: number | null;
  disableNumberOfPortsAndPipesPerPortCalculation: boolean;
  isMountedUpsideDown: boolean;
};

export const mapDesignManifoldDetailsResponseToFormModel = (
  response: DesignManifoldDetailsResponse,
): DesignManifoldDetailsFormModel => ({
  flowTemperatureInDegreesCelsius: response.flowTemperatureInDegreesCelsius?.toString() ?? '',
  disableNumberOfPortsAndPipesPerPortCalculation: response.disableNumberOfPortsAndPipesPerPortCalculation,
  isMountedUpsideDown: response.isMountedUpsideDown,
});
